import { atom } from "recoil";

export const ConfigState = new atom({
  default: { login: "", password: "" },
  key: "ConfigState",
});
